import { StakeSection } from '@/components/dashboard/StakeSection'

export function StakePage() {
  return (
    <div style={{ maxWidth: 1280, margin: '0 auto', padding: '24px' }}>
      <StakeSection />
    </div>
  )
}
